<template>
  <div class="edrea_tm_section" id="contact">
    <div class="section_inner">
      <div class="edrea_tm_contact">
        <div class="edrea_tm_main_title">
          <h3>
            {{ t.contact.titleLight }}
            <span class="coloring">{{ t.contact.titleColored }}</span>
          </h3>
        </div>
        <div class="wrapper">
          <div class="left">
            <ul>
              <li>
                <div class="list_inner">
                  <i class="icon-location"></i>
                  <span
                    ><a
                      href="https://maps.google.com/?q=Edificio Holcim, Blvd Orden de Malta, Urbanizacion Madre Selva III, El Salvador"
                      target="_blank"
                      class="href_location"
                      >{{ t.contact.address }}</a
                    ></span
                  >
                </div>
              </li>
              <li>
                <div class="list_inner">
                  <i class="icon-mail-1"></i>
                  <span
                    ><a href="mailto:ventas.sv@datamindss.com"
                      >ventas.sv@datamindss.com</a
                    ></span
                  >
                </div>
              </li>
              <li>
                <div class="list_inner">
                  <i class="icon-phone"></i>
                  <span><a href="tel:+50322210128">+503 2221 0128</a></span>
                </div>
              </li>
            </ul>

            <!-- CTA de WhatsApp: abre el chat con el mensaje ya escrito -->
            <a
              class="wa_button"
              :href="whatsappLink"
              target="_blank"
              rel="noopener"
            >
              <i class="icon-whatsapp"></i>
              <span class="wa_texts">
                <strong>{{ t.contact.whatsapp }}</strong>
                <small>{{ t.contact.whatsappNumber }}</small>
              </span>
            </a>
          </div>
          <div class="right">
            <div class="fields">
              <form class="contact_form" id="contact_form" @submit.prevent="send">
                <div v-if="sent" class="returnmessage">
                  {{ t.contact.success }}
                </div>
                <div v-if="error" class="contact_error">{{ error }}</div>
                <div class="first">
                  <ul>
                    <li>
                      <div class="list_inner">
                        <input
                          id="name"
                          v-model="form.name"
                          type="text"
                          :placeholder="t.contact.namePlaceholder"
                          autocomplete="off"
                        />
                      </div>
                    </li>
                    <li>
                      <div class="list_inner">
                        <input
                          id="email"
                          v-model="form.email"
                          type="email"
                          :placeholder="t.contact.emailPlaceholder"
                          autocomplete="off"
                        />
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="last">
                  <textarea
                    id="message"
                    v-model="form.message"
                    :placeholder="t.contact.messagePlaceholder"
                  ></textarea>
                </div>

                <!-- Trampa antispam: invisible para las personas, los bots la llenan -->
                <input
                  v-model="form.website"
                  type="text"
                  class="hp_field"
                  tabindex="-1"
                  autocomplete="off"
                  aria-hidden="true"
                />

                <div class="edrea_tm_button">
                  <a
                    id="send_message"
                    href="#"
                    :class="{ disabled: loading }"
                    @click.prevent="send"
                    >{{ loading ? t.contact.sending : t.contact.send }}</a
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/i18n";

// Mismo origen que el chat de Sofía: el nginx del contenedor proxea el prefijo
// /api/sofia/web/ hacia el backend interno, que envía el correo a ventas.
const CONTACT_API =
  process.env.VUE_APP_CONTACT_API || "/api/sofia/web/contact";

const WHATSAPP_NUMBER = "50374689732";

export default {
  name: `ContactComponent`,
  data() {
    return {
      form: { name: "", email: "", message: "", website: "" },
      loading: false,
      sent: false,
      error: "",
    };
  },
  computed: {
    t() {
      return i18n.m;
    },
    whatsappLink() {
      const text = encodeURIComponent(this.t.contact.whatsappMessage);
      return `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
    },
  },
  methods: {
    async send() {
      if (this.loading) return;

      const name = this.form.name.trim();
      const email = this.form.email.trim();
      const message = this.form.message.trim();

      this.sent = false;
      this.error = "";

      if (!name || !email || !message) {
        this.error = this.t.contact.required;
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.error = this.t.contact.invalidEmail;
        return;
      }

      this.loading = true;
      try {
        const res = await fetch(CONTACT_API, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            email,
            message,
            website: this.form.website,
          }),
        });

        if (res.status === 429) {
          this.error = this.t.contact.rateLimit;
          return;
        }
        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        this.sent = true;
        this.form = { name: "", email: "", message: "", website: "" };
      } catch (e) {
        this.error = this.t.contact.error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* ── Botón de WhatsApp ── */
.wa_button {
  /* La lista de contacto usa li flotantes: sin clear el botón se le encima */
  clear: both;
  float: left;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 20px;
  padding: 14px 20px;
  border-radius: 10px;
  background-color: #25d366;
  color: #fff !important;
  text-decoration: none;
  box-shadow: 0 8px 20px rgba(37, 211, 102, 0.25);
  transition: all 0.3s ease;
}
.wa_button:hover {
  background-color: #1da851;
  transform: translateY(-2px);
}
.wa_button i {
  font-size: 24px;
  color: #fff;
}
.wa_texts {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}
.wa_texts strong {
  font-weight: 600;
  font-size: 15px;
}
.wa_texts small {
  font-size: 13px;
  opacity: 0.9;
}

/* Honeypot: fuera de la vista pero sin display:none (los bots lo detectan) */
.hp_field {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  opacity: 0;
}

#send_message.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.contact_error,
.returnmessage {
  margin-bottom: 12px;
}
</style>
